import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface UserState {
  username: string | null;
  profilePictureKey: string | null;
}

const initialState: UserState = {
  username: null,
  profilePictureKey: null,
};

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    setProfilePictureKey: (state, action: PayloadAction<string>) => {
      state.profilePictureKey = action.payload;
    },
    clearUsername: state => {
      state.username = null;
    },
    clearProfilePictureKey: state => {
      state.profilePictureKey = null;
    },
  },
});

// Export the actions
export const { setUsername, clearUsername, setProfilePictureKey, clearProfilePictureKey } = userReducer.actions;
